export default __webpack_public_path__ + "images/707f3665c29419e09e612feaa42afdb0-background.svg";